import type { DOMNode } from "html-react-parser";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

export const capitalizeInitialLetter = (sentence: string) => {
  const words = sentence.split(" ");
  const exclude = [
    "a",
    "an",
    "the",
    "at",
    "by",
    "for",
    "in",
    "of",
    "on",
    "to",
    "up",
    "and",
    "as",
    "but",
    "or",
    "nor",
    "(e.g.,",
  ];
  for (let i = 0; i < words.length; i++) {
    if (!exclude.includes(words[i].toLowerCase())) {
      words[i] = words[i]
        .toLowerCase()
        .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    }
  }
  return words.join(" ").replace(/\s+/g, " ");
};

export const htmlFromString = (str: string) => {
  const safeHtml = DOMPurify.sanitize(str);
  return parse(safeHtml, {
    replace: (domNode: DOMNode) => {
      if (domNode.type === "tag" && domNode.name === "a" && domNode.attribs) {
        // Modify attributes without overwriting existing ones
        domNode.attribs = {
          ...domNode.attribs,
          target: "_blank",
          rel: "noopener",
          className: "no-underline hover:underline text-primary",
        };
        // Return undefined to let html-react-parser render the modified node
        return undefined;
      }
      // Return undefined for non <a> tags to let html-react-parser handle them
      return undefined;
    },
  });
};

export const isHTML = (htmlContent: string | null | undefined): boolean => {
  if (!htmlContent) {
    return false;
  }
  const isHtml = /<\/?[a-z][\s\S]*>/i.test(htmlContent);
  return isHtml;
};

export const escapeRegExp = (string: string) => {
  return string?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const normalizeText = (string: string) => {
  return string?.replace(/[\u2019\u00A0]/g, (match) =>
    match === "\u2019" ? "'" : " ",
  );
};

export const lowerCaseComparison = (
  str1: string | undefined | null,
  str2: string | undefined | null,
) => {
  if (!str1 || !str2) {
    return false;
  }
  return str1?.toLowerCase() === str2?.toLowerCase();
};
